<!-- Fondo oscuro -->
<div
  class="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 animate-fade-in"
  (click)="close.emit()"
></div>

<!-- Contenedor modal -->
<div
  class="fixed top-1/2 left-1/2 z-50 w-full max-w-md -translate-x-1/2 -translate-y-1/2 
         bg-white rounded-2xl shadow-2xl p-6 animate-scale-in"
  (click)="$event.stopPropagation()"
>
  <!-- Header -->
  <header class="flex text-blue-700 items-center justify-between border-b pb-3 mb-5">
    <h2 class="text-lg text-blue-700 font-semibold">Filtrar facturas</h2>
    <button (click)="close.emit()" class="text-gray-500 hover:text-gray-700 transition cursor-pointer">
      <span class="material-symbols-outlined text-xl">close</span>
    </button>
  </header>

  <!-- Filtro de fechas -->
  <section class="mb-6">
    <h3 class="text-sm font-semibold text-gray-700 mb-2">Rango de fechas</h3>
    <app-date-filter (dateRangeSelected)="onDateRangeSelected($event)"></app-date-filter>
  </section>

  <!-- Filtro por texto -->
  <section class="mb-6">
    <h3 class="text-sm font-semibold text-gray-700 mb-2">Búsqueda por nombre</h3>
    <input
      type="text"
      [(ngModel)]="filterText"
      placeholder="Nombre o número"
      class="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm
             focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    />
  </section>

  <!-- Filtro por estatus -->
  <section class="mb-6">
    <h3 class="text-sm font-semibold text-gray-700 mb-2">Estatus</h3>
    <select
      [(ngModel)]="selectedStatus"
      class="w-full border border-gray-300 rounded-xl px-3 py-2.5 text-sm
             focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    >
      <option value="">Todos</option>
      <option value="Pagada">Pagada</option>
      <option value="Pendiente">Pendiente</option>
      <option value="Dada de baja">Dada de baja</option>
    </select>
  </section>

  <!-- Botones -->
  <footer class="flex justify-end gap-3 mt-6">
    <button
      (click)="close.emit()"
      class="text-gray-600 hover:text-gray-800 text-sm font-medium transition cursor-pointer"
    >
      Cancelar
    </button>
    <button
      (click)="apply()"
      class="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-2 rounded-lg transition cursor-pointer"
    >
      Aplicar
    </button>
  </footer>
</div>
